<template>
    <div class="exposure-box" ref="trackedElement">
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'ExposureBox',
    props: {

    },
    data() {
        return {
            hasShown1px: false, // 标记1px露出事件是否已触发
            hasTriggered50Percent: false, // 标记50%+1s事件是否已触发
            fiftyPercentVisibleStartTime: null,
            isIn50PercentState: false,
            observer: null,
        }
    },
    async mounted() {
        setTimeout(() => {
            this.initObserver()
        }, 1000)
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.unobserve(this.$refs.trackedElement)
        }
    },
    methods: {
        checkElementsOverflow(element) {
            const rect = element.getBoundingClientRect()
            const viewportWidth =
                window.innerWidth || document.documentElement.clientWidth
            const viewportHeight =
                window.innerHeight || document.documentElement.clientHeight

            // 判断元素是否完全在视口外
            const isCompletelyOutOfViewport =
                rect.right <= 0 ||
                rect.left >= viewportWidth ||
                rect.bottom <= 0 ||
                rect.top >= viewportHeight

            if (isCompletelyOutOfViewport) {
                return true
            }

            // 检查元素是否被任何父容器裁剪（包括trackedElement及其祖先）
            let isClippedByParent = false
            let parent = element.parentElement // 从直接父元素开始检查
            const trackedElement = this.$refs.trackedElement

            while (parent && parent !== document.body) {
                // 到达目标容器后停止向上检查
                if (parent === trackedElement) {
                    break
                }

                const parentRect = parent.getBoundingClientRect()
                const style = window.getComputedStyle(parent)
                const overflow = style.overflow + style.overflowX + style.overflowY

                // 只有当父容器有溢出隐藏时才检查裁剪
                if (overflow.indexOf('hidden') !== -1) {
                    const isOutOfParent =
                        rect.right <= parentRect.left ||
                        rect.left >= parentRect.right ||
                        rect.bottom <= parentRect.top ||
                        rect.top >= parentRect.bottom

                    if (isOutOfParent) {
                        isClippedByParent = true
                        break
                    }
                }

                parent = parent.parentElement
            }

            // 最后检查是否被目标容器本身裁剪
            if (!isClippedByParent && trackedElement) {
                const trackedRect = trackedElement.getBoundingClientRect()
                const isOutOfTracked =
                    rect.right <= trackedRect.left ||
                    rect.left >= trackedRect.right ||
                    rect.bottom <= trackedRect.top ||
                    rect.top >= trackedRect.bottom

                isClippedByParent = isOutOfTracked
            }

            return isClippedByParent
        },
        initObserver() {
            const element = this.$refs.trackedElement
            if (!element) return

            const options = {
                root: null,
                rootMargin: '0px',
                threshold: [0, 0.5, 1.0],
            }

            this.observer = new IntersectionObserver(entries => {
                this.handleIntersection(entries[0])
            }, options)

            this.observer.observe(element)
        },
        handleIntersection(entry) {
            const { isIntersecting, intersectionRatio } = entry

            // 处理露出1px的情况（只触发一次）
            if (isIntersecting && intersectionRatio > 0 && !this.hasShown1px) {
                this.hasShown1px = true
                setTimeout(() => {
                    console.log('组件已露出1px')
                    this.$emit('exposure', 'hasShown1px')
                }, 1000)
            }

            // 处理露出50%且停留超过1秒的情况（只触发一次）
            if (!this.hasTriggered50Percent) {
                // 只有在未触发过时才处理
                if (isIntersecting && intersectionRatio >= 0.5) {
                    if (!this.isIn50PercentState) {
                        this.isIn50PercentState = true
                        this.fiftyPercentVisibleStartTime = Date.now()
                        setTimeout(() => {
                            // 检查1秒后是否仍处于50%可见状态且未触发过事件
                            if (this.isIn50PercentState && !this.hasTriggered50Percent) {
                                this.hasTriggered50Percent = true // 标记为已触发
                                console.log('组件已露出50%并停留超过1秒')
                                this.$emit('exposure', 'hasTriggered50Percent')
                            }
                        }, 1000)
                    }
                } else {
                    this.isIn50PercentState = false
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.exposure-box {
    position: relative;
    width: 100%;
    height: 100%;

    // &::before {
    //     position: absolute;
    //     z-index: 9999;
    //     top: 10px;
    //     width: 10px;
    //     height: 10px;
    //     content: '';
    //     border-radius: 50%;
    // }

    // &.hasShown1px {
    //     &::before {
    //         left: 10px;
    //         background-color: red;
    //     }
    // }

    // &.hasTriggered50Percent {
    //     &::before {
    //         left: 20px;
    //         background-color: blue;
    //     }
    // }
}
</style>
